import { ServerBaseEntity } from '@iris/common/models/ServerBaseEntity';
import { copyValues } from '@iris/common/utils/object.utils';
import { IrisFieldsTranslationSet } from '@iris/common/models/translations';

export const IRIS_APPLICATION_ALIAS = 'iris';

export interface IrisApplicationI extends ServerBaseEntityI {
  enabled?: boolean;
  applicationAlias: string;
  name: string;
  nameTranslated: string;
  description: string;
  descriptionTranslated: string;
  logo: string;
  image: string;
  translations?: IrisFieldsTranslationSet;
  projectSelectorEnabled: boolean;
  globalSearchEnabled: boolean;
}

export class IrisApplication extends ServerBaseEntity<IrisApplicationI> implements IrisApplicationI {
  enabled: boolean = undefined;
  applicationAlias: string = undefined;
  name: string = undefined;
  nameTranslated = undefined;
  description: string = undefined;
  descriptionTranslated: string = undefined;
  logo: string = undefined;
  image: string = undefined;
  projectSelectorEnabled = false;
  globalSearchEnabled = false;
  translations?: IrisFieldsTranslationSet = {};

  constructor(params?: IrisApplicationI) {
    super(params);
    if (params) {
      copyValues(this, params);
    }
  }
}
